import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('sv', sv);

const EditDate = ({ value, setValue, dateFormat, onKeyDown, isInvalid, onSave, autoFocus }) => {

    const datePickerFormat = 'yyyy-MM-dd';
    const dateTime = value && value.length ? moment(value, dateFormat).toDate() : '';

    const setDateTime = (date) => {
        const momentDate = moment(date);
        if (momentDate.isValid()) {
            setValue(moment(date).format(dateFormat));
        }
        else {
            setValue('');
        }
    };

    const inputRef = useRef();
    const handleFocus = () => {
        if (inputRef?.current) {
            inputRef.current.input.select();
        }
    };
    useEffect(() => {
        if (value === '' && autoFocus) {
            setDateTime(new Date());
        }
        autoFocus && handleFocus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='crm-editable-field-wrapper'>
            <DatePicker
                dateFormat={datePickerFormat}
                selected={dateTime}
                onChange={(date) => setDateTime(date)}
                locale='sv'
                showMonthDropdown={true}
                showYearDropdown={true}
                // onCalendarClose={onSave}
                placeholderText='ÅÅÅÅ-MM-DD'
                ref={inputRef}
                className={`text-input ${isInvalid ? 'invalid' : ''}`}
                onKeyDown={onKeyDown}
            />
        </div>
    );
};

export default EditDate;
